import { Component, ElementRef, Input, OnInit, EventEmitter, TemplateRef, ViewChild, Output } from '@angular/core';
import { Stripe, StripeElements, StripeCardNumberElement, StripeCardExpiryElement, StripeCardCvcElement } from '@stripe/stripe-js';
import { SubscriptionService } from '../../services/subscription.service';
import { AuthService } from '../../services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-subscription',
    templateUrl: './subscription.component.html',
    styleUrls: ['subscription.component.css']
})
export class SubscriptionComponent implements OnInit {
    @ViewChild('cardNumberElement') cardNumberElement: ElementRef;
    @ViewChild('cardExpiryElement') cardExpiryElement: ElementRef;
    @ViewChild('cardCvcElement') cardCvcElement: ElementRef;

    // Accepting subscriptionDetails and userName as inputs
    @Input() public subscriptionDetails: any;
    @Input() public userName: string;

    @Output() subscriptionDetailsChange = new EventEmitter<{ dailyReport: boolean }>();

    public isAddDaysView: boolean = false;
    public daysToPurchase: number;
    public errorMessage: string | null = null;
    public username = null;
    
    private stripe: Stripe | null = null;
    private elements: StripeElements | null = null;

    private cardNumber: StripeCardNumberElement | null = null;
    private cardExpiry: StripeCardExpiryElement | null = null;
    private cardCvc: StripeCardCvcElement | null = null;

    constructor(private authService: AuthService,
        private subscriptionService: SubscriptionService,
        private spinnerService: Ng4LoadingSpinnerService,) { 
            this.username = this.authService.currentUser.userName;
        }

    async ngOnInit() {
        this.stripe = await this.subscriptionService.getStripeInstance();
    }

    async ngAfterViewInit() {
        // Stripe elements will be initialized when `isAddDaysView` becomes true
        $('.selectpicker').selectpicker('refresh');
    }

    async addMoreDays() {
        this.isAddDaysView = true;
        // Initialize Stripe elements after `isAddDaysView` is true and elements are in the DOM
        this.setupStripeElement();
    }

    async showAccountSettings() {
        this.isAddDaysView = false;
    }

    private async setupStripeElement() {
        if (!this.stripe) {
            this.authService.showNotification('', 'Stripe instance is not available.', 'error');
            return;
        }

        this.elements = this.stripe.elements();

        // Ensure the view is fully loaded and elements are in the DOM
        setTimeout(() => {
            if (this.cardNumberElement && this.cardExpiryElement && this.cardCvcElement) {
                this.cardNumber = this.elements.create('cardNumber');
                this.cardNumber.mount(this.cardNumberElement.nativeElement);

                this.cardExpiry = this.elements.create('cardExpiry');
                this.cardExpiry.mount(this.cardExpiryElement.nativeElement);

                this.cardCvc = this.elements.create('cardCvc');
                this.cardCvc.mount(this.cardCvcElement.nativeElement);
            }
        }, 0);
    }

    async handleAccountSubscriptionSubmit(event: Event) {
        event.preventDefault();

        // Call the PaymentService to create the token
        if (this.cardNumber) {

            var max = 365;
            var min = 7;
            if (this.daysToPurchase < min || this.daysToPurchase > max) {
                this.spinnerService.hide();
                this.authService.showNotification('', 'Number of days should be between </br> 7 and 365', 'error');
                return;
            }

            this.spinnerService.show();
            const { token, error } = await this.subscriptionService.createPaymentToken(this.cardNumber);

            if (error) {
                this.spinnerService.hide();
                this.authService.showNotification('', 'Some error occured please try again later', 'error');
                console.log('Payment Error:', error);
            } else if (token) {
                let request = {
                    token: token.id,
                    userName: this.userName,
                    noOfDaysToPurchase: this.daysToPurchase,
                    FirstName: $("#txtFirstName").val(),
                    LastName: $("#txtLastName").val(),
                    Address: $("#txtAddress").val(),
                    Address2: $("#txtAddress2").val(),
                    Country: $("#txtCountry").val(),
                    City: $("#txtCity").val(),
                    State: $("#txtState").val(),
                    Zip: $("#txtZip").val()
                }

                this.subscriptionService.processPayment(request).subscribe(
                    (response) => this.handleProcessPaymentResponse(response),
                    (err) => this.handleProcessPaymentError(err)
                );
            }
        }
    }

    handleProcessPaymentResponse(response: any) {
        this.spinnerService.hide();

        if (response.status == "success") {
            this.authService.showNotification('', response.message, 'success');
            this.spinnerService.show();

            this.subscriptionService.getSubscriptionDetails(this.userName).subscribe(
                (response) => {
                    if (response && response.data) {
                        this.subscriptionDetails = response.data;
                        this.daysToPurchase = 1;
                        this.isAddDaysView = false;
                        this.spinnerService.hide();
                    }
                },
                (error) => {
                    this.spinnerService.hide();
                    this.authService.showNotification('', 'Some error occured please try again later', 'error');
                }
            );
        } else {
            this.authService.showNotification('', response.message, 'error');
        }
    }
    
    handleProcessPaymentError(error) {
        console.log('Payment error:', error)
        this.spinnerService.hide();
        this.authService.showNotification('', 'Some error occured please try again later', 'error');
    }

    isValid(): boolean {
        
        this.errorMessage = null;
        if($("#txtFirstName").val() === '') {
            this.errorMessage = 'First Name is mandatory.';
            return false;
        }
        if($("#txtLastName").val() === '') {
            this.errorMessage = 'Last Name is mandatory.';
            return false;
        }
        if (this.daysToPurchase === null || this.daysToPurchase === undefined) {
            this.errorMessage = 'Input cannot be empty.';
            return false;
        }
        // if (this.daysToPurchase < 7) {
        //     this.errorMessage = 'Minimum value is 7.';
        //     return false;
        // }
        // if (this.daysToPurchase > 365) {
        //     this.errorMessage = 'Maximum value is 365.';
        //     return false;
        // }
        return true;
    }

    onToggleDailyReport(event) {
        this.subscriptionDetails.dailyReport = event.target.checked;
        this.subscriptionDetailsChange.emit(this.subscriptionDetails);
    }

    saveAccountSettings() {
        this.spinnerService.show();
        this.subscriptionService.UpdateAccountSettings(this.subscriptionDetails).subscribe((response) => {
            this.spinnerService.hide();
            if (response.status === 'error') {
                this.authService.showNotification(response.message, '', 'error');
            } else {
                $("button.close").click();
                this.authService.showNotification('Account settings saved successfully', 'success', 'success');
            }
          }, error => {
              this.spinnerService.hide();
              this.authService.showNotification('', 'Some error occured. please try again later', 'error');
        });
    }

    btnFullYearClick() {
        this.daysToPurchase = 365;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/subscription/subscription.component.ts